import {V3BadgeTypeType} from '@wix/ambassador-events-v3-event/types'
import {IStylesGetParam} from '@wix/tpa-settings/dist/src/contexts/StylesContext/StylesContext.types'
import {
  EVENT_BADGE_LAYOUT,
  ITEM_HEIGHT_TYPE,
  LIST_IMAGE_SIZE,
  LIST_LAYOUT,
  LIST_LOCATION_AND_DATE_FORMAT,
  MOBILE_LIST_LAYOUT_TYPE,
  MOBILE_WIDGET_LAYOUT,
  WIDGET_TYPE,
} from '@wix/wix-events-commons-statics'
import stylesParams from './stylesParams'
import {BadgeType, EVENT_BADGE_TYPE} from './Widget/utils/event-badges'

export const StyleSelectors = (get: IStylesGetParam, mobile: boolean) => {
  const getWidgetType = () => get(stylesParams.widgetType)

  const getMobileWidgetLayout = () => get(stylesParams.mobileWidgetLayoutNew)

  const getMobileListLayoutType = () => get(stylesParams.mobileWidgetListLayoutType)

  const isMobileCalendarLayout = () => getMobileWidgetLayout() === MOBILE_WIDGET_LAYOUT.CALENDAR

  const isMobileListLayout = () => getMobileWidgetLayout() === MOBILE_WIDGET_LAYOUT.LIST

  const isMobileListLayoutTypeFull = () => getMobileListLayoutType() === MOBILE_LIST_LAYOUT_TYPE.FULL

  const isMultiEventWidget = () => getWidgetType() === WIDGET_TYPE.LIST

  const isFeaturedWidget = () => getWidgetType() === WIDGET_TYPE.FEATURED

  const isMobileCompactLayout = () =>
    (isMultiEventWidget() || isFeaturedWidget()) && isMobileListLayout() && !isMobileListLayoutTypeFull()

  const isListAdditionalInfoEnabled = () => get(stylesParams.listShowAdditionalInfo)

  const isListDescriptionEnabled = () => get(stylesParams.listShowDescription)

  const isListCountdownEnabled = () => get(stylesParams.listShowCountdown)

  const isListSocialShareEnabled = () => get(stylesParams.listShowSocialShare)

  const isListMembersEnabled = () => get(stylesParams.listShowMembers)

  const isListAdditionalComponentsVisible = () => {
    if (mobile && isMobileCompactLayout()) {
      return false
    }
    return (
      isListAdditionalInfoEnabled() &&
      (isListExtraInfoDateVisible() ||
        isListExtraInfoLocationVisible() ||
        isListDescriptionEnabled() ||
        isListSocialShareEnabled())
    )
  }

  const isListImageEnabled = () => get(stylesParams.listShowImage)

  const isListMainTitleEnabled = () => get(stylesParams.listShowMainTitle)

  const isListDateVisible = () => get(stylesParams.listShowDateV2)

  const isListLocationVisible = () => get(stylesParams.listShowLocationV2)

  const isListExtraInfoDateVisible = () => get(stylesParams.listExtraInfoShowDate)

  const isListExtraInfoLocationVisible = () => get(stylesParams.listExtraInfoShowLocation)

  const isListDateAndLocationContainerVisible = () => isListDateVisible() || isListLocationVisible()

  const isListDateLocationFormatShort = () =>
    get(stylesParams.listLocationAndDateFormatV2) === LIST_LOCATION_AND_DATE_FORMAT.COMPACT

  const isListDateLocationFormatFull = () =>
    get(stylesParams.listLocationAndDateFormatV2) === LIST_LOCATION_AND_DATE_FORMAT.FULL

  const isListShortDateLocationVisible = () =>
    isListDateAndLocationContainerVisible() && isListDateLocationFormatShort()
  const isListFullDateLocationVisible = () => isListDateAndLocationContainerVisible() && isListDateLocationFormatFull()
  const isListExtraInfoDateOrLocationVisible = () => isListExtraInfoDateVisible() || isListExtraInfoLocationVisible()

  const isListShortDateVisible = () => isListDateVisible() && isListDateLocationFormatShort()
  const isListFullDateVisible = () => isListDateVisible() && isListDateLocationFormatFull()

  const isListShortLocationVisible = () => isListLocationVisible() && isListDateLocationFormatShort()
  const isListFullLocationVisible = () => isListLocationVisible() && isListDateLocationFormatFull()

  const isFixedItemHeight = () => get(stylesParams.itemHeightType) === ITEM_HEIGHT_TYPE.FIXED

  const forceEventBadgeInEventInfo = () => {
    const listLayout = get(stylesParams.listLayout)
    const onImageLayout = mobile
      ? getMobileWidgetLayout() === MOBILE_WIDGET_LAYOUT.ON_IMAGE
      : listLayout === LIST_LAYOUT.ON_IMAGE

    return (
      !isListImageEnabled() ||
      onImageLayout ||
      (mobile
        ? isMobileListLayout() && !isMobileListLayoutTypeFull()
        : listLayout === LIST_LAYOUT.LIST && get(stylesParams.listImageSize) === LIST_IMAGE_SIZE.SMALL)
    )
  }
  const isEventBadgeOnImage = (eventBadgeType: BadgeType | V3BadgeTypeType, calendar = false) =>
    isEventBadgeVisible(eventBadgeType) &&
    getEventBadgeLayout(calendar) === EVENT_BADGE_LAYOUT.ON_IMAGE &&
    !forceEventBadgeInEventInfo()

  const isEventBadgeInEventInfo = (eventBadgeType: BadgeType | V3BadgeTypeType, calendar = false) =>
    isEventBadgeVisible(eventBadgeType) &&
    (getEventBadgeLayout(calendar) === EVENT_BADGE_LAYOUT.EVENT_INFO || forceEventBadgeInEventInfo())

  const getEventBadgeLayout = (calendar: boolean) =>
    calendar ? get(stylesParams.calendarEventBadgeLayout) : get(stylesParams.eventBadgeLayout)

  const isEventBadgeVisible = (eventBadgeType: BadgeType | V3BadgeTypeType) =>
    eventBadgeType === EVENT_BADGE_TYPE.FIRST_PRIORITY || eventBadgeType === V3BadgeTypeType.FIRST_PRIORITY
      ? get(stylesParams.showFirstPriorityEventBadge)
      : eventBadgeType === EVENT_BADGE_TYPE.SECOND_PRIORITY || eventBadgeType === V3BadgeTypeType.SECOND_PRIORITY
      ? get(stylesParams.showSecondPriorityEventBadge)
      : get(stylesParams.showThirdPriorityEventBadge)

  return {
    isFeaturedWidget,
    isMultiEventWidget,
    isMobileCompactLayout,
    isMobileCalendarLayout,
    isListAdditionalInfoEnabled,
    isListDescriptionEnabled,
    isListCountdownEnabled,
    isListSocialShareEnabled,
    isListMembersEnabled,
    isListAdditionalComponentsVisible,
    isListImageEnabled,
    isListMainTitleEnabled,
    isFixedItemHeight,
    isListDateVisible,
    isListLocationVisible,
    isListDateAndLocationContainerVisible,
    isListShortDateLocationVisible,
    isListFullDateLocationVisible,
    isListExtraInfoDateVisible,
    isListExtraInfoLocationVisible,
    isListShortDateVisible,
    isListFullDateVisible,
    isListShortLocationVisible,
    isListFullLocationVisible,
    isListExtraInfoDateOrLocationVisible,
    isEventBadgeOnImage,
    isEventBadgeInEventInfo,
  }
}
